<template>
  <div class="page">
    <LoadingSpinner v-if="processing" id="loading-spinner" />
    <div id="action-bar">
      <input type="search" placeholder="Find marker..." v-model="query" />
      <button class="primary" @click="addMarker">Add marker</button>
    </div>
    <table
      v-for="(marker, index) in markersFound"
      :key="'marker-' + index"
      class="marker-table"
      @click="addPanel('panel-edit-marker', marker)"
    >
      <tr>
        <td colspan="2">
          {{ marker.id }}
        </td>
      </tr>
      <tr>
        <td>Name</td>
        <td>{{ marker.name }}</td>
      </tr>
      <tr>
        <td>Type</td>
        <td>{{ marker.type }}</td>
      </tr>
      <tr>
        <td>Unit</td>
        <td>{{ marker.unit }}</td>
      </tr>
      <tr>
        <td>Description</td>
        <td>{{ marker.description }}</td>
      </tr>
      <tr>
        <td>Range</td>
        <td>
          <div
            v-for="(range, rangeIndex) in marker.range"
            :key="'range-' + index + '-' + rangeIndex"
            class="inline-range"
          >
            <div :style="{ 'background-color': range.color }"></div>
            {{ range.title }}: {{ range.value }}
          </div>
        </td>
      </tr>
    </table>

    <PanelEditMarker />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import PanelEditMarker from "./PanelEditMarker";
import { mapState } from "vuex";

import "vue-swatches/dist/vue-swatches.min.css";

export default {
  name: "AdminMarkers",
  data() {
    return {
      processing: false,
      query: ""
    };
  },
  components: {
    LoadingSpinner,
    PanelEditMarker
  },
  methods: {
    async addMarker() {
      const id = prompt("Marker ID");
      if (!id) return;
      this.processing = true;
      const marker = await this.$store.dispatch("KitsStore/addMarker", { id });
      this.processing = false;
      this.$nextTick(() => {
        this.addPanel("panel-edit-marker", marker);
      });
    }
  },
  computed: {
    ...mapState("KitsStore", ["markers"]),
    markersFound() {
      if (this.query === "") return this.markers;
      return this.markers.filter(
        marker =>
          marker.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1 ||
          marker.id.toLowerCase().indexOf(this.query.toLowerCase()) > -1
      );
    }
  },
  async mounted() {
    this.processing = true;
    await this.$store.dispatch("KitsStore/markersSubscribe");
    this.processing = false;
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";

.marker-table {
  background-color: #eee;
  margin-bottom: @h1;
  cursor: pointer;
  tr {
    &:first-child {
      td {
        height: @h4;
        background-color: #333;
        color: #fff;
        vertical-align: middle;
        font-size: 1.2rem;
        font-weight: bold;
      }
    }
    td {
      padding: @hh;
      &:first-child {
        width: 150px;
      }

      .inline-range {
        display: flex;
        margin-bottom: 0.25em;
        div {
          width: @h2;
          margin-right: 0.5em;
        }
      }
    }
  }
}
</style>
